<select  
    [id]="id" 
    [name]="name" 
    [attr.required]="isRequired ? true : null"    
    [disabled]="isDisabled"
    [class]="selectClass +' form-select pe-4 text-truncate'" 
    [(ngModel)]="selectedValue" 
    (ngModelChange)="valueChanged.emit($event)"
    [ngClass]="{'readonly-field': isDisabled}"
    >
    <option value=""></option>
    <option *ngFor="let option of options" [value]="option.id" [disabled]="optionDisable?.includes(option.id)">
        {{ option.name }}
    </option>
</select>
